import { Link } from "react-router-dom";
import { Package, BookOpen, Link2 } from "lucide-react";

const navItems = [
  {
    path: "/products",
    icon: Package,
    title: "Products",
    description: "Apps, tools, and things we've built",
  },
  {
    path: "/story",
    icon: BookOpen,
    title: "Story",
    description: "The journey of anotherwhy",
  },
  {
    path: "/connect",
    icon: Link2,
    title: "Connect",
    description: "GitHub, LinkedIn, and more",
  },
];

export function QuickNav() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto mt-12">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className="block h-full p-6 rounded-lg border border-[--border-primary] bg-[--bg-secondary] hover:border-[--olive]/50 hover:bg-[--olive]/5 transition-all group"
        >
          <item.icon className="size-8 text-[--olive] mb-3 group-hover:scale-110 transition-transform" />
          <h3 className="font-semibold text-[--text-primary] mb-1 group-hover:text-[--olive] transition-colors">
            {item.title}
          </h3>
          <p className="text-sm text-[--text-muted]">
            {item.description}
          </p>
          <span className="inline-block mt-3 text-sm text-[--olive] opacity-0 group-hover:opacity-100 transition-opacity">
            Explore →
          </span>
        </Link>
      ))}
    </div>
  );
}
